<GoogleTagManager> </GoogleTagManager><router-view />
<!-- This will render the current route's component -->